import React, { useState } from "react";
import { Copy, Check, ShieldCheck } from "lucide-react";
import { Button, fmtDate } from "../../Primitives";
import { Modal } from "./UserDialog";

export default function InviteLink({ invite, email, onClose }) {
  const [copied, setCopied] = useState(false);
  const [manual, setManual] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(invite.invite_url); }
    catch (e) {
      const el = document.querySelector('[data-testid="invite-link-url"]');
      el?.select();
      if (!document.execCommand?.("copy")) { setManual(true); return; }
    }
    setCopied(true); setTimeout(() => setCopied(false), 2000);
  };
  return (
    <Modal title="Link de convite gerado" onClose={onClose} testid="invite-link-dialog">
      <div className="grid gap-3 text-[13px]">
        <p className="text-[var(--muted)]">Envie este link para <strong className="text-[var(--text)]">{email}</strong> por um canal privado. A pessoa definirá a própria senha.</p>
        <div className="flex gap-2">
          <input readOnly value={invite.invite_url} onFocus={(e) => e.target.select()} className="mia-input mono !text-[11px]" data-testid="invite-link-url" aria-label="Link de convite" />
          <Button variant="outline" size="sm" onClick={copy} data-testid="invite-link-copy">{copied ? <Check size={13} /> : <Copy size={13} />} {copied ? "Copiado" : "Copiar"}</Button>
        </div>
        {manual && <p className="ops-help" role="status" data-testid="invite-link-manual" style={{ color: "var(--warn)" }}>Não foi possível copiar automaticamente. O link está selecionado: copie manualmente (Ctrl+C).</p>}
        <div className="flex gap-2 p-2.5 rounded-[var(--radius-sm)] border border-[var(--accent-line)] bg-[var(--accent-weak)]">
          <ShieldCheck size={15} className="shrink-0 mt-0.5 text-[var(--accent-ink)]" />
          <p className="ops-help !text-[var(--muted)]">Uso único, expira em {fmtDate(invite.invite_expires_at)}. Este link não será exibido novamente — se perdê-lo, gere um novo (o anterior é invalidado). O envio automático por e-mail ainda não está configurado.</p>
        </div>
        <div className="flex justify-end"><Button size="sm" onClick={onClose} data-testid="invite-link-done">Concluir</Button></div>
      </div>
    </Modal>
  );
}
